import axios from 'axios';
import React, { useReducer, useMemo, useRef, useEffect, useCallback, createContext, useContext } from 'react';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function (d, b) {
  extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
  };
  return extendStatics(d, b);
};
function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

var GENERAL_ERROR = 'Something went wrong. Please try again.';
var NETWORK_ERROR = 'A network error has occurred. Please check your internet connection.';

var WebServiceError = /** @class */ (function (_super) {
    __extends(WebServiceError, _super);
    function WebServiceError(message, payload, code) {
        var _this = _super.call(this, message) || this;
        _this.processedMessage = function (customMessage) {
            if (_this.code >= 7000 && _this.code < 8000) {
                return _this.message;
            }
            if (_this.code >= 8000 && _this.code < 9000) {
                return _this.message || customMessage || GENERAL_ERROR;
            }
            return GENERAL_ERROR;
        };
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, WebServiceError);
        }
        _this.name = 'WebServiceError';
        _this.payload = payload || {};
        _this.code = code || 1;
        _this.processed = true;
        return _this;
    }
    return WebServiceError;
}(Error));

var isObject = function (input) {
    return typeof input !== 'function' && input instanceof Object && !(input instanceof Array);
};
var isObjectOrArray = function (input) { return typeof input !== 'function' && input instanceof Object; };
/**
 * A partial (curried) function that can be used to create other normalizer functions. This handles
 * the recursion that would be redundant in most other normalizers.
 * @param {Function} normalizeFunc Function that is called on each key of the input
 * @returns {Function}
 */
var objectKeyNormalizer = function (normalizeFunc) {
    var normalizer = function (input, overrides) {
        if (overrides === void 0) { overrides = {}; }
        if (!isObjectOrArray(input)) {
            return input;
        }
        // if input is an array map through array applying recursion
        if (input instanceof Array) {
            return input.map(function (elem) { return normalizer(elem, overrides); });
        }
        return Object.keys(input).reduce(function (acc, oldKey) {
            var newKey = Object.keys(overrides).includes(oldKey) ? overrides[oldKey] : normalizeFunc(oldKey);
            acc[newKey] = input[oldKey];
            // check if this is a nested object and use recursion
            if (isObject(acc[newKey])) {
                acc[newKey] = normalizer(acc[newKey], overrides);
            }
            if (acc[newKey] instanceof Array) {
                acc[newKey] = acc[newKey].map(function (elem) { return normalizer(elem, overrides); });
            }
            return acc;
        }, {});
    };
    return normalizer;
};
/**
 * Idempotent operation to recursively normalize object key casing to camel case. Will work
 * on any input
 * @param {Object} input any input that may be an object that has capital cased keys.
 * @param {Object} overrides (optional) An object of key value pairs to specify and exact replacement for a key name
 * @returns {Object}
 */
var camelCaseNormalizer = objectKeyNormalizer(function (oldKey) { return "".concat(oldKey[0].toLocaleLowerCase()).concat(oldKey.substr(1)); });
/**
 * Idempotent operation to recursively normalize object key casing to capital case. Will work
 * on any input
 * @param {Object} input any input that may be an object that has capital cased keys.
 * @param {Object} overrides (optional) An object of key value pairs to specify and exact replacement for a key name
 * @returns {Object}
 */
var capitalCaseNormalizer = objectKeyNormalizer(function (oldKey) { return "".concat(oldKey[0].toLocaleUpperCase()).concat(oldKey.substr(1)); });

var processError = function (e) {
    var _a, _b, _c;
    // Destructure message and code if you can
    var _d = ((_a = e.response) === null || _a === void 0 ? void 0 : _a.data) ? camelCaseNormalizer(e.response.data) : {}, message = _d.message, code = _d.code;
    // Check for network error.
    if (!message && !((_b = e.response) === null || _b === void 0 ? void 0 : _b.status)) {
        throw new Error(NETWORK_ERROR);
    }
    return new WebServiceError(message, (_c = e.response) === null || _c === void 0 ? void 0 : _c.data, code);
};
var processLegacyError = function (e) {
    var _a, _b;
    // Destructure message and code if you can
    var _c = e || {}, message = _c.message, code = _c.code;
    // Check for network error.
    if (!message && !((_a = e.response) === null || _a === void 0 ? void 0 : _a.status)) {
        throw new Error(NETWORK_ERROR);
    }
    return new WebServiceError(message, (_b = e.response) === null || _b === void 0 ? void 0 : _b.data, code);
};
// This is a misnomer since it throws and error and doesn't really generate one. This
// has already been exported and used so I am not keen to change its behavior.
var generateError = function (e, defaultError, customError) {
    var error = processError(e);
    console.error(error);
    var newError = new Error(error.processedMessage(customError || defaultError));
    newError.code = error.code;
    throw newError;
};
/**
 * wraps the provided function in error generic error handling code to automatically work with
 * Amtrav 7000-9000 error codes.
 *
 * @param {function} func The function that is being wrapped with the error handling code.
 * @returns function
 */
var makeErrorHandledFunction = function (func) {
    return function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, func.apply(void 0, params).catch(function (err) {
                            return generateError(err);
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
};

const lowestFareDataUrl = (origin, destination) => `/api/v2/AirLowFareCalendar/${origin}/${destination}`;
const lowestFareReturnDataUrl = (origin, destination, departDate) => {
  return `/api/v1/AirLowFareCalendar/${origin}/${destination}/${departDate}`;
};
const fetchLowestFareData = async _ref => {
  let {
    origin,
    destination,
    customError
  } = _ref;
  const res = await axios.get(lowestFareDataUrl(origin, destination)).catch(e => generateError(e, `Could not fetch lowest fares for ${origin} and ${destination}.`, customError));
  return res.data;
};
const fetchLowestReturnData = async _ref2 => {
  let {
    origin,
    destination,
    departDate,
    customError
  } = _ref2;
  const res = await axios.get(lowestFareReturnDataUrl(origin, destination, departDate)).catch(e => generateError(e, 'Could not fetch returning fares.', customError));
  return res.data;
};

/**
 * Deletes entries in Storage to clear the cached responses.
 *
 * @param {string} prefix A string used to determine which keys to delete from storage
 */
const clearCacheByPrefix = function () {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ATS';
  return Object.keys(window.localStorage).filter(k => k.indexOf(prefix) === 0).map(key => {
    window.localStorage.removeItem(key);
    return key;
  });
};

/**
 * Calls the clearCacheByPrefix function if the page was reloaded.
 * It is advised to use this function outside of any render functions.
 *
 * @param {string} prefix A string used to determine which keys to delete from storage
 */
const clearCacheOnReload = function () {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ATS';
  return window.performance.navigation.type === 1 ? clearCacheByPrefix(prefix) : [];
};
const removeInvalidEntries = prefix => {
  const allKeys = Object.keys(window.localStorage).filter(k => k.indexOf(prefix) === 0);
  const legacyKeys = Object.keys(window.localStorage).filter(k => k.indexOf('CACHE_') === 0);
  allKeys.concat(legacyKeys).forEach(key => {
    const entry = window.localStorage.getItem(key);
    try {
      const item = JSON.parse(entry);
      if (new Date().getTime() >= (item === null || item === void 0 ? void 0 : item.expires)) {
        window.localStorage.removeItem(key);
      }
    } catch (err) {
      // if the entry can't be parsed by JSON just ignore it.
      if (err.name !== 'SyntaxError') {
        throw err;
      }
    }
  });
};

/**
 * Default opts object used by the withCache function
 *
 * @property prefix Prefixes the key used in Storage
 * @property name sets the name used with the prefix to generate a key
 * @property ttl The time to live for the cache as milliseconds.
 */
const cacheDefaultOpts = {
  prefix: 'ATS',
  name: 'cached_webservice',
  ttl: 1800000 // 30 minutes
};
const defaultKeyGenerator = (prefix, name, argumentsList) => {
  return `${prefix}_${name}_${JSON.stringify(argumentsList)}`;
};

/**
 * Creates a JS Proxy that will decorate the webservice function with
 * caching features.
 *
 * @param {function} webservice A function that returns a promise.
 * @param {object} opts Options object
 * @param {function} keyGenerator Optional override to generate the cache key
 */
const withCache = function (webservice) {
  let overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let keyGenerator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultKeyGenerator;
  return async function () {
    const opts = {
      ...cacheDefaultOpts,
      name: webservice.name,
      ...overrides
    };
    removeInvalidEntries(opts.prefix);
    for (var _len = arguments.length, argumentsList = new Array(_len), _key = 0; _key < _len; _key++) {
      argumentsList[_key] = arguments[_key];
    }
    const cacheKey = keyGenerator(opts.prefix, opts.name, argumentsList);
    const cachedResultString = window.localStorage.getItem(cacheKey);
    const cachedResult = JSON.parse(cachedResultString);
    if (new Date().getTime() < (cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.expires)) {
      return cachedResult.result;
    }
    const result = await webservice(...argumentsList);
    const cacheValue = JSON.stringify({
      result,
      expires: Number(new Date().getTime()) + opts.ttl
    });
    try {
      window.localStorage.setItem(cacheKey, cacheValue);
    } catch (err) {
      // If the cache is too large, clear out all entries from this
      if (err.name === 'QuotaExceededError') {
        clearCacheByPrefix(opts.prefix);
        window.localStorage.setItem(cacheKey, cacheValue);
      } else {
        throw err;
      }
    }
    return result;
  };
};

const availableSettings = ['air', 'car', 'hotel'];
const BOOKING_ATTACHMENT_TYPES = {
  NOT_OFFERED: 'NotOffered',
  OFFERED: 'Offered',
  BOOKED: 'Booked',
  DECLINED: 'Declined'
};
const INVITE_STATUS_TYPES = {
  COMPLETED: 'Completed',
  NOT_ATTENDING: 'WillNotAttend',
  IN_PROGRESS: 'InProgress',
  INVITATION_PENDING: 'InvitationPending'
};
const RSVP_STATUSES = {
  NOT_RESPONDED: 'NotResponded',
  WILL_NOT_ATTEND: 'WillNotAttend',
  WILL_ATTEND: 'WillAttend'
};
const fetchMeetings = async () => {
  const res = await axios.get('/api/v1/meetings').catch(e => generateError(e, 'Could not fetch meetings.'));
  return res.data;
};
const fetchMeetingsRefData = async () => {
  const res = await axios.get('/api/v1/meetings/referenceData').catch(e => generateError(e, 'Could not fetch meetings.'));
  return res.data;
};
const fetchMeetingById = async meetingId => {
  try {
    const res = await axios.get(`/api/v1/meetings/${meetingId}`);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not fetch meeting.');
  }
};
const fetchMeetingByInvitationToken = async invitationToken => {
  try {
    const res = await axios.get(`/api/v1/meetings/invitations/${invitationToken}`);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not fetch meeting.');
  }
};
const downloadRoomList = async (meetingId, propId) => {
  try {
    const res = await axios.get(`/api/v1/meetings/${meetingId}/hotel/${propId}/downloadroomlist`);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not download room list.');
  }
};
const downloadAttendeeList = async meetingId => {
  try {
    const res = await axios.get(`/api/v1/meetings/${meetingId}/downloadattendees`);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not download attendee list.');
  }
};
const downloadFlightReport = async meetingId => {
  try {
    const res = await axios.get(`/api/v1/meetings/${meetingId}/flights/downloadreport`);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not download flight report.');
  }
};
const downloadCventAirActuals = async meetingId => {
  try {
    const res = await axios.get(`/api/v1/meetings/${meetingId}/flights/downloadcventreport`);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not download Cvent Air Actuals report.');
  }
};
const postMeeting = async meetingData => {
  try {
    const res = await axios.post('/api/v1/meetings', meetingData);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not post meeting.');
  }
};
const postCloneMeeting = async (meetingId, payload) => {
  try {
    const res = await axios.post(`/api/v1/meetings/${meetingId}/clone`, payload);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not clone meeting.');
  }
};
const postMeetingInvitation = async (meetingId, payload) => {
  try {
    const res = await axios.post(`/api/v1/meetings/${meetingId}/invitations`, payload);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not post meeting invite.');
  }
};
const getPatchFields$1 = payload => Object.keys(payload).map(key => {
  if (payload[key] instanceof Array) {
    return key;
  }
  return Object.keys(payload[key]).map(fieldName => `${key}.${fieldName}`);
}).join(',');
const patchMeeting = async (meetingId, meetingData) => {
  const patchFields = getPatchFields$1(meetingData);
  try {
    const res = await axios.patch(`/api/v1/meetings/${meetingId}`, {
      patchFields,
      ...meetingData
    });
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not patch meeting.');
  }
};
const deleteMeeting = async meetingId => {
  try {
    const res = await axios.delete(`/api/v1/meetings/${meetingId}`);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not delete meeting.');
  }
};
const getAttendees = async meetingId => {
  try {
    const res = await axios.get(`/api/v1/meetings/${meetingId}/attendees`);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not get attendees.');
  }
};
const getInvites = async function () {
  let namenum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  const endpoint = namenum ? `/api/v2/meetings/invitations?nameNum=${namenum}` : '/api/v2/meetings/invitations';
  try {
    const res = await axios.get(endpoint);
    return res.data;
  } catch (err) {
    const error = processError(err);
    // If no meetings were found that is not really an exception.
    if (error.message === 'No meeting was found') {
      return [];
    }
    throw error;
  }
};
const getAttendeeBookings = async (meetingId, attendeeId, booknum) => {
  try {
    const res = await axios.get(`/api/v1/meetings/${meetingId}/attendees/${attendeeId}/booking/${booknum}`);
    return res.data;
  } catch (err) {
    throw generateError(err, 'Could not get attendee booking.');
  }
};

// Room Blocks modal
const getLoyaltyNumbers = async invitationToken => {
  try {
    const res = await axios.get(`/api/v1/meetings/loyaltyNumbers/${invitationToken}`);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not get loyalty numbers.');
  }
};

/**
 * Clears out the settings for air, car, or hotel.
 * @param {string} meetingId
 * @returns {Object}
 */
const deleteSettings = async (meetingId, settingType) => {
  if (!availableSettings.includes(settingType)) {
    throw new Error(`${settingType} not supported. Use one of ${availableSettings.join(', ')}`);
  }
  try {
    const res = await axios.delete(`/api/v1/meetings/${meetingId}/${settingType}Settings`);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not delete air settings.');
  }
};

/**
 * POSTs a meeting to the attendees endpoint. Payload has the following shape:
 * {
 *   "email": "raulm@amtrav.com",
 *   "NameNum": 17355150,
 *   "policyId": 32,
 *   "attendeeType":"RegisteredTraveler"
 * }
 * @param {string} meetingId
 * @param {Object} payload JSON serializable object
 * @returns {Object}
 */
const addAttendee = async (meetingId, payload) => {
  try {
    const res = await axios.post(`/api/v1/meetings/${meetingId}/attendees`, payload);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not post attendee.');
  }
};

/**
 * POSTs a meeting to the attendees endpoint. Payload has the following shape:
 * {
 *   "email": "sample1@amtrav.com,sample2@amtrav.com",
 *   "policyId": 32,
 *   "additionalTravelers" : 1
 * }
 * @param {string} meetingId
 * @param {Object} payload JSON serializable object
 * @returns {Object}
 */
const addMultipleAttendees = async (meetingId, payload) => {
  try {
    const res = await axios.post(`/api/v2/meetings/${meetingId}/attendees`, payload);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not post attendees.');
  }
};

/**
 * Disassociates an attendee from the meeting
 * @param {string} meetingId
 * @param {string} attendeeId
 * @returns {Object}
 */
const deleteAttendee = async (meetingId, attendeeId) => {
  try {
    const res = await axios.delete(`/api/v1/meetings/${meetingId}/attendees/${attendeeId}`);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not delete attendee.');
  }
};

/**
 * Updates status of air, hotel, or car for an attendee to either declined or undeclined
 * @param {string} meetingId
 * @param {string} attendeeId
 * @param {boolean} isDeclined
 * @param {string} part ['air', 'hotel', 'car']
 * @param {string} reason Optional reason for option out.
 * @returns {Object}
 */
const setDeclineStatus = async function (meetingId, attendeeId, isDeclined, part) {
  let reason = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  try {
    if (!availableSettings.includes(part)) {
      throw new Error(`${part} not supported. Use one of ${availableSettings.join(', ')}`);
    }
    const declineStatus = isDeclined ? 'decline' : 'undecline';
    const res = await axios.patch(`/api/v1/meetings/${meetingId}/attendees/${attendeeId}/${declineStatus}`, {
      part,
      reason
    });
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not delete attendee.');
  }
};

/**
 * Updates status of air, hotel, or car for an attendee to either declined or undeclined
 * @param {string} meetingId
 * @param {string} attendeeId
 * @param {string} rsvpStatus
 * @returns {Object}
 */
const setRsvpStatus = async (meetingId, attendeeId, rsvpStatus) => {
  try {
    const res = await axios.patch(`/api/v1/meetings/${meetingId}/attendees/${attendeeId}/rsvpstatus`, {
      rsvpStatus
    });
    return res.data;
  } catch (err) {
    return generateError(err, 'Could update rsvp status.');
  }
};

/**
 * Updates an attendee associated to the meeting. Payload has the following shape:
 * {
 *   "policyId": 1000,
 *   "attendeeType":"RegisteredTraveler"
 * }
 * @param {string} meetingId
 * @param {string} attendeeId
 * @param {Object} payload JSON serializable object
 * @returns {Object}
 */
const updateAttendee = async (meetingId, attendeeId, payload) => {
  try {
    const res = await axios.put(`/api/v1/meetings/${meetingId}/attendees/${attendeeId}`, payload);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not update attendee.');
  }
};
const postExpeditedBooking = async bookingData => {
  try {
    const res = await axios.post('/api/v1/meetings/expeditedBooking', bookingData);
    return res.data;
  } catch (err) {
    return generateError(err, 'Error posting expedited booking.');
  }
};
const addRoomBlock = async (meetingId, propId, arrivalDate, departureDate, numRooms, nightlyRate, nightlyTax) => {
  const apiUrl = `/api/v1/meetings/${meetingId}/RoomBlock`;
  const requestData = {
    PropId: propId,
    ArrivalDate: arrivalDate,
    DepartureDate: departureDate,
    NumRooms: numRooms,
    NightlyRate: nightlyRate,
    NightlyTax: nightlyTax
  };
  const config = {
    headers: {
      'Content-Type': 'application/json'
    }
  };
  return axios.post(apiUrl, requestData, config).catch(error => {
    generateError(error, 'Could not create room block.');
  });
};
const deleteRoomBlock = async (meetingId, roomBlockId) => {
  const apiUrl = `/api/v1/meetings/${meetingId}/RoomBlock/${roomBlockId}`;
  const config = {
    headers: {
      'Content-Type': 'application/json'
    }
  };
  return axios.delete(apiUrl, config).catch(error => {
    generateError(error, 'Could not create room block.');
  });
};

const locationDataUrl = locId => `/ws/search/GetLocationKey?queryparams={locid:'${locId}'}`;
const fetchLocationData = async (locId, customError) => {
  const {
    data
  } = await axios.get(locationDataUrl(locId)).catch(e => generateError(e, 'Could not fetch location data.', customError));
  return data;
};

/**
 * @param propId: string - Property ID
 */
const getHotelDetails = async (propId, customError) => {
  const {
    data
  } = await axios.get(`/ws/hotels/GetHotelDetails/${propId}`).catch(e => generateError(e, 'Could not fetch hotel data.', customError));
  return data;
};

const shopForFlights = params => {
  const endpoint = '/ws/airshop/ShopForFlights';
  return axios.create({
    withCredentials: true
  }).get(endpoint, {
    params: {
      queryparams: {
        ...params,
        condenseResponse: true,
        withShelves: true
      }
    },
    headers: {
      'WS-Orig-Path': window.location.href
    }
  }).then(res => res.data).catch(err => {
    return generateError(err);
  });
};
const seatAvailability = (payload, config) => {
  const {
    aircraftTypeCode,
    airlineCode,
    arrives,
    bic = 'Y',
    departs,
    flightNumber,
    fromCode,
    toCode,
    nameNum = -1
  } = payload;
  // eslint-disable-next-line max-len
  const url = `/api/v2/SeatMap/Preview?arrives=${arrives}&departs=${departs}&fromCode=${fromCode}&toCode=${toCode}&airlineCode=${airlineCode}&aircraftTypeCode=${aircraftTypeCode}&flightNumber=${flightNumber}&bic=${bic}&nameNum=${nameNum}`;
  return axios.get(url, config);
};
const fetchSeatMapByBookNum = async (payload, config) => {
  const {
    bn
  } = payload;
  const url = `/api/v1/SeatMap/${bn}`;
  try {
    const res = await axios.get(url, config);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not fetch seat map');
  }
};
const shopForFlightsKeyGen = (prefix, name, params) => {
  /*
  We do not want the `searchId` to be part of the cache key. The `searchId` is important for the back-end to optimize 
  follow-up calls (e.g., filtering), but it will unnecessarily create unique keys and invalidate the front-end cache. 
  We use destructuring to remove the `searchId`.
  */

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {
    searchId: _,
    ...usedFields
  } = params[0];

  /*
  JavaScript does not guarantee the order of object properties. Therefore, we stringify the parameters (usedFields) 
  and sort the characters to generate a unique key.
  */
  const key = JSON.stringify(usedFields).split('').filter(c => !['"', ',', ':'].includes(c)) // remove non-unique characters to further simplify the key
  .sort().join('');
  return `${prefix}_${name}_${key}`;
};
const shopForFlightsWithCache = withCache(shopForFlights, {
  ttl: 300000
}, shopForFlightsKeyGen);
const clearShopForFlightsCache = () => clearCacheByPrefix('ATS_ShopForFlights');

const travelAlertsUrl = '/api/v1/travelAlerts';
const fetchTravelAlerts = async legs => {
  const res = await axios.post(travelAlertsUrl, {
    list: [...legs]
  });
  return res.data;
};

const makeFindLocations = function () {
  let cancelToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  return function (searchString) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const endpoint = '/ws/search/FindLocations';
    const queryparams = {
      searchString
    };
    if (opts.mode !== undefined) {
      queryparams.mode = opts.mode;
    }
    if (opts.keyTypes !== undefined) {
      queryparams.keyTypes = opts.keyTypes;
    }
    if (opts.filterMask !== undefined) {
      queryparams.filterMask = opts.filterMask;
    }
    const requestOptions = {
      params: {
        queryparams
      },
      headers: {
        'WS-Orig-Path': window.location.href
      }
    };
    if (cancelToken) {
      requestOptions.cancelToken = cancelToken;
    }
    return axios.get(endpoint, requestOptions).then(res => res.data).catch(err => {
      if (axios.isCancel(err)) {
        throw new Error(`CANCELLED_REQUEST: ${err.message}`);
      }
      console.error(err);
      throw err;
    });
  };
};
const findLocations = makeFindLocations();
const cancellableFindLocations = () => {
  const source = axios.CancelToken.source();
  return {
    findLocations: makeFindLocations(source.token),
    cancelFindLocations: reason => source.cancel(reason)
  };
};
const makeFindLocationsNearBy = function () {
  let cancelToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  return function (searchString, refLocId) {
    let opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const endpoint = '/ws/search/FindLocationsNearBy';
    const queryparams = {
      searchString,
      refLocId
    };
    if (opts.mode !== undefined) {
      queryparams.mode = opts.mode;
    }
    if (opts.keyTypes !== undefined) {
      queryparams.keyTypes = opts.keyTypes;
    }
    if (opts.filterMask !== undefined) {
      queryparams.filterMask = opts.filterMask;
    }
    const requestOptions = {
      params: {
        queryparams
      },
      headers: {
        'WS-Orig-Path': window.location.href
      }
    };
    if (cancelToken) {
      requestOptions.cancelToken = cancelToken;
    }
    return axios.get(endpoint, requestOptions).then(res => res.data).catch(err => {
      if (axios.isCancel(err)) {
        throw new Error(`CANCELLED_REQUEST: ${err.message}`);
      }
      console.error(err);
      throw err;
    });
  };
};
const cancellableFindLocationsNearBy = () => {
  const source = axios.CancelToken.source();
  return {
    findLocationsNearBy: makeFindLocationsNearBy(source.token),
    cancelFindLocationsNearBy: reason => source.cancel(reason)
  };
};
const findLocationsNearBy = makeFindLocationsNearBy();

const fetchCmsPost = (cmsCode, cmsPostType, cmsPostId) => {
  const endpoint = '/api/v1/cms/posts';
  return axios.get(endpoint, {
    params: {
      cmsCode,
      postType: cmsPostType,
      postSlug: cmsPostId
    },
    headers: {
      'WS-Orig-Path': window.location.href
    }
  }).then(res => res.data).catch(err => {
    console.error(err);
    throw err;
  });
};

const endpoint = '/ws/customers/SubscriberAddModify';
const emailSubscriber = function (email, homeCityCode) {
  let subscriptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    couponSpecial: true,
    fareFlash: true,
    fareIntelligence: true,
    vacationPicks: true
  };
  return axios.get(endpoint, {
    params: {
      queryparams: {
        email,
        homeCityCode,
        subscriptions
      }
    },
    headers: {
      'WS-Orig-Path': window.location.href
    }
  }).then(res => res.data).catch(e => generateError(e));
};

const fetchInvariantData = async customError => {
  const {
    data
  } = await axios.get(`/ws/lookup/GetInvariantData?_=${Date.now()}`).catch(e => generateError(e, 'Could not fetch location data.', customError));
  return data;
};
const fetchAccountData = async customError => {
  const {
    data
  } = await axios.get(`/ws/customers/AccountGet?queryparams={}&_=${Date.now()}`).catch(e => generateError(e, 'Could not fetch account data.', customError));
  return data;
};
const fetchPolicy = async (policyId, customError) => {
  const {
    data
  } = await axios.get(`/ws/customers/PolicyGet?queryparams={"policyId":${policyId}}&_=${Date.now()}`).catch(e => generateError(e, 'Could not fetch policy data.', customError));
  return data;
};
const getAirportOptions = async function (toId) {
  let fromId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  let customError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  const fromParam = fromId ? `%22fromId%22:%22${fromId}%22,` : '';
  const params = `{${fromParam}%22toId%22:%22${toId}%22}&_=${Date.now()}`;
  const {
    data
  } = await axios.get(`/ws/lookup/GetAirportOptions?queryparams=${params}`).catch(e => generateError(e, 'Could not fetch location data.', customError));
  return data;
};
const fetchUserData = async function (nameNum) {
  let customError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  const params = `%7B%22namenum%22%3A%22${nameNum}%22%7D`;
  const {
    data
  } = await axios.get(`/ws/customers/UserGet?queryparams=${params}`).catch(e => generateError(e, 'Could not fetch User Data.', customError));
  return data;
};
const getUserData = async customError => {
  const {
    data
  } = await axios.get(`/ws/customers/UserGet?queryparams={}&_=${Date.now()}`).catch(e => generateError(e, 'Could not fetch user data.', customError));
  return data;
};

// /ws/customers/GetLogOnProfile?queryparams={"withViewSettings":true,"withBookForList":true,"withUnusedTickets":true}
const getLogonProfile = async (queryparams, customError) => {
  const params = queryparams || {
    withViewSettings: true,
    withBookForList: true,
    withUnusedTickets: true
  };
  const {
    data
  } = await axios.get(`/ws/customers/GetLogOnProfile?queryparams=${encodeURIComponent(JSON.stringify(params))}&_=${Date.now()}`).catch(e => generateError(e, 'Could not fetch user logon profile.', customError));
  return data;
};
const fetchTripsData = async namenum => {
  try {
    const res = await axios.get('/ws/bookings/BookingGetListCorporate', {
      params: {
        queryparams: {
          nameNum: Number(namenum)
        },
        _: Date.now()
      }
    });
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not send data.');
  }
};
const getCustomerTravelerInfo = async function () {
  let nameNum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  let isPersonal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  try {
    const res = await axios.get(`/ws/customers/GetTravelerInfo?queryparams={"nameNum":${nameNum},"isPersonal":${isPersonal}}`);
    return res.data;
  } catch (err) {
    return generateError(err);
  }
};

var bookingApproveOrReject = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios
                    .get("/ws/bookings/BookingApproveOrReject?queryparams=".concat(JSON.stringify(payload)))
                    .catch(function (err) {
                    return generateError(err);
                })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
var bookingsByTripSegment = function () {
    var args_1 = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args_1[_i] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (nameNum) {
        var nameNumObj, data;
        if (nameNum === void 0) { nameNum = ''; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    nameNumObj = nameNum ? { nameNum: nameNum } : {};
                    return [4 /*yield*/, axios
                            .get("/ws/bookings/BookingsByTripSegment?queryparams=".concat(JSON.stringify(nameNumObj)))
                            .catch(function (err) {
                            return generateError(err, 'Could not fetch trips.');
                        })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
var fetchBookingComponents = function (bookingNum) { return __awaiter(void 0, void 0, void 0, function () {
    var res, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios.get("/api/v1/ChangeTrip/Options/".concat(bookingNum))];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data];
            case 2:
                err_1 = _a.sent();
                return [2 /*return*/, generateError(err_1, 'Could not fetch booking.')];
            case 3: return [2 /*return*/];
        }
    });
}); };
var manageTripsCheck = function (bookingNum, payload) { return __awaiter(void 0, void 0, void 0, function () {
    var res, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios.post("/api/v1/ChangeTrip/Check/".concat(bookingNum), payload)];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data];
            case 2:
                err_2 = _a.sent();
                return [2 /*return*/, generateError(err_2, 'Could not check changes.')];
            case 3: return [2 /*return*/];
        }
    });
}); };
var manageTripsSendEmail = function (bookingNum, payload) { return __awaiter(void 0, void 0, void 0, function () {
    var res, err_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios.post("/api/v1/ChangeTrip/SendEmail/".concat(bookingNum), payload)];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data];
            case 2:
                err_3 = _a.sent();
                return [2 /*return*/, generateError(err_3, 'Could not send data.')];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * This is used to load the Change Trip Center
 * @param {string|number} changeTripId The changeTripId associated with the request.
 * @returns {Promise<Object>}
 */
var getChangeTripActions = function (changeTripId) { return __awaiter(void 0, void 0, void 0, function () {
    var res, err_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios.get("/api/v1/ChangeTrip/AutomatedActions/".concat(changeTripId))];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data];
            case 2:
                err_4 = _a.sent();
                return [2 /*return*/, generateError(err_4, "Could not fetch actions for ".concat(changeTripId))];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * This is to make incremental changes to update newCar, newHotel or newFlights chosen after a exchange re-shopping.
 * It should also be used to set AgreedToTerms on each section.
 * @param {string|number} exchangeId Exchange ID provided by backend while re-shopping
 * @param {Object} payload New trip component data
 * @returns {Promise<Object>}
 */
var patchChangeTripActions = function (exchangeId, payload) { return __awaiter(void 0, void 0, void 0, function () {
    var patchFields, res, err_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                patchFields = Object.keys(payload).join(',');
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios.patch("/api/v1/ChangeTrip/AutomatedActions/".concat(exchangeId), __assign({ patchFields: patchFields }, payload))];
            case 2:
                res = _a.sent();
                return [2 /*return*/, res.data];
            case 3:
                err_5 = _a.sent();
                return [2 /*return*/, generateError(err_5, 'Could not update this trip.')];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * This is for the final submission when everything is done to make the actual changes
 * @param {string|number} bookingNum Booking number associated with the changes
 * @param {string|number} changeTripId The changeTripId associated with the changes
 * @param {Object} payload The data representing the final submission. This will most likely be empty
 * @returns {Promise<Object>}
 */
var changeTripApplyChanges = function (bookingNum, changeTripId, payload) { return __awaiter(void 0, void 0, void 0, function () {
    var res, err_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios.post("/api/v1/ChangeTrip/ApplyChanges/".concat(bookingNum, "/").concat(changeTripId), payload)];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data];
            case 2:
                err_6 = _a.sent();
                return [2 /*return*/, generateError(err_6, 'Could not send data.')];
            case 3: return [2 /*return*/];
        }
    });
}); };
var editTripTitle = function (bookingNum, newTripTitle) { return __awaiter(void 0, void 0, void 0, function () {
    var apiUrl, requestData, config;
    return __generator(this, function (_a) {
        apiUrl = "/api/v1/bookings/".concat(bookingNum);
        requestData = {
            PatchFields: 'forcetitle',
            ForceTitle: newTripTitle,
        };
        config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };
        return [2 /*return*/, axios.patch(apiUrl, requestData, config).catch(function (error) {
                generateError(error, 'Could not rename trip.');
            })];
    });
}); };
var editTripBillingTags = function (bookingNum, anum, newBillingFields) { return __awaiter(void 0, void 0, void 0, function () {
    var apiUrl, requestData, config;
    return __generator(this, function (_a) {
        apiUrl = "/api/v1/bookings/".concat(bookingNum);
        requestData = {
            PatchFields: 'billingreferences',
            Anum: anum,
            BillingReferences: newBillingFields,
        };
        config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };
        return [2 /*return*/, axios.patch(apiUrl, requestData, config).catch(function (error) {
                generateError(error, 'Could not update billing tags.');
            })];
    });
}); };

// Hard code this here for legacy urls
var Ws$1 = {
    B: { Url: '/ws/bookings' },
    Cus: { Url: '/ws/customers' },
};
var postCreateBookingService = function (payload, config) { return __awaiter(void 0, void 0, void 0, function () {
    var err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios.post("".concat(Ws$1.B.Url, "/BookingCreateModify"), payload, config)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                err_1 = _a.sent();
                return [2 /*return*/, generateError(err_1)];
            case 3: return [2 /*return*/];
        }
    });
}); };
var postBookingCancelService = function (payload, config) {
    return axios.post("".concat(Ws$1.B.Url, "/BookingCancel"), payload, config);
};
var postEmailItinService = function (payload, config) {
    return axios.post('/api/v1/email/confirmation', payload, config);
};
var getBookingService = function (payload, config) { return __awaiter(void 0, void 0, void 0, function () {
    var err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios.get("".concat(Ws$1.B.Url, "/BookingGet?queryparams=").concat(JSON.stringify(payload)), config)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                err_2 = _a.sent();
                throw generateError(err_2);
            case 3: return [2 /*return*/];
        }
    });
}); };
var bookingModPendingAlert = function (payload, config) {
    return axios.get("".concat(Ws$1.B.Url, "/BookingModPendingAlert?queryparams=").concat(JSON.stringify(payload)), config);
};
var getTravelerInfo = function (payload, config) {
    return axios.get("".concat(Ws$1.Cus.Url, "/GetTravelerInfo?queryparams=").concat(JSON.stringify(payload)), config);
};
var getPdpCheck = function (payload, config) { return __awaiter(void 0, void 0, void 0, function () {
    var err_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios.get("".concat(Ws$1.B.Url, "/PDPPriceCheck?queryparams=").concat(JSON.stringify(payload)), config)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                err_3 = _a.sent();
                throw generateError(err_3);
            case 3: return [2 /*return*/];
        }
    });
}); };

var Ws = {
    H: { Url: '/ws/hotels' },
};
// Deprecated
var getHotels = function (payload, config) {
    return axios.get("".concat(Ws.H.Url, "/GetHotels?queryparams=").concat(JSON.stringify(payload)), config);
};
// Deprecated (use SSE)
var getHotelsMultiSource = function (payload, config) { return __awaiter(void 0, void 0, void 0, function () {
    var err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios.get("".concat(Ws.H.Url, "/GetHotelsMultiSource?queryparams=").concat(JSON.stringify(payload)), config)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                err_1 = _a.sent();
                throw generateError(err_1);
            case 3: return [2 /*return*/];
        }
    });
}); };
var getHotelVCardImages = function (payload, config) {
    return axios.get("/api/v1/virtualcard/hotel/cardimage?".concat(payload), config);
};
// disable this while testing
var postVirtualCardInfoService = function (payload, config) {
    return axios.post('/api/v1/virtualcard/hotel/sendfax', payload, config);
};
var getHotelProperty = function (hotelPropId) { return __awaiter(void 0, void 0, void 0, function () {
    var res, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios.get("/api/v1/hotels/".concat(hotelPropId))];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data];
            case 2:
                err_2 = _a.sent();
                return [2 /*return*/, generateError(err_2)];
            case 3: return [2 /*return*/];
        }
    });
}); };
var getHotelRooms = function (_a) { return __awaiter(void 0, void 0, void 0, function () {
    var endpoint, res, err_3;
    var propId = _a.propId, rest = __rest(_a, ["propId"]);
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                endpoint = "/api/v1/hotels/".concat(propId, "/rooms");
                return [4 /*yield*/, axios.get(endpoint, {
                        params: __assign({}, rest),
                    })];
            case 1:
                res = _b.sent();
                return [2 /*return*/, res.data];
            case 2:
                err_3 = _b.sent();
                return [2 /*return*/, generateError(err_3)];
            case 3: return [2 /*return*/];
        }
    });
}); };
var postRoomDetails = function (rate, checkInDate, checkOutDate, hotelDetails, chainCode, numAdults, numChildren) { return __awaiter(void 0, void 0, void 0, function () {
    var payload, response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = {
                    numAdults: numAdults,
                    count: 1,
                    numChildren: numChildren,
                    arrives: checkInDate,
                    departs: checkOutDate,
                    chainCode: chainCode,
                    propId: hotelDetails.propId,
                    rateCode: rate.ratePlanCode,
                    corporateDiscountCode: rate.corporateDiscountCode,
                    pricing: {
                        currency: rate.currency,
                        rate: rate.averageNightlyRate,
                    },
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios.post('/api/v1/Hotel/Room/Details', payload, {
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })];
            case 2:
                response = _a.sent();
                return [2 /*return*/, response.data];
            case 3:
                error_1 = _a.sent();
                console.error('Error:', error_1);
                return [2 /*return*/, 'Unable to fetch Rate Details.'];
            case 4: return [2 /*return*/];
        }
    });
}); };
var getHotelReviews = function (hotelPropId) { return __awaiter(void 0, void 0, void 0, function () {
    var res, err_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios.get("/api/v1/hotels/".concat(hotelPropId, "/reviews"))];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data];
            case 2:
                err_4 = _a.sent();
                return [2 /*return*/, generateError(err_4)];
            case 3: return [2 /*return*/];
        }
    });
}); };

var downloadFile = function (url, config) {
    if (config === void 0) { config = {}; }
    return axios.get(url, __assign(__assign({}, config), { responseType: 'blob' })).then(function (response) {
        // First, IE actually has a thing for this
        if (navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(response.data, config.fileName || 'download');
        }
        else {
            // This is a bit of a hack to allow us to track and download a binary blob (PDF)
            var blobURL = window.URL.createObjectURL(response.data);
            var tempLink = document.createElement('a');
            tempLink.style.display = 'none';
            tempLink.href = blobURL;
            tempLink.download = config.fileName || 'download';
            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(blobURL);
            return true;
        }
        return true;
    });
};
var downloadBlob = function (blob, config) {
    // First, IE actually has a thing for this
    if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, (config === null || config === void 0 ? void 0 : config.fileName) || 'download');
    }
    else {
        // This is a bit of a hack to allow us to track and download a binary blob (PDF)
        var blobURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        tempLink.download = (config === null || config === void 0 ? void 0 : config.fileName) || 'download';
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(blobURL);
        return true;
    }
    return true;
};

const registerUser = async payload => {
  try {
    var _res$data;
    const res = await axios.post(`/scriptService/signin.asmx/Register`, payload);
    const responseText = camelCaseNormalizer(JSON.parse(res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 || (_res$data = _res$data.d) === null || _res$data === void 0 ? void 0 : _res$data.responseText));
    if (responseText !== null && responseText !== void 0 && responseText.isErrorResponse) {
      const err = processLegacyError(responseText);
      console.error(err);
      throw err;
    }
    return res.data;
  } catch (e) {
    var _e$response;
    if (e.processed) {
      throw e;
    }
    if ((e === null || e === void 0 || (_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.status) !== 200) {
      // When non 200 errors come back it is almost always a system error.
      throw new Error(processError(e).processedMessage());
    }
    console.error(e);
  }
};

const postSignUpAttempt = async (payload, config) => {
  try {
    return await axios.post('/api/v1/Subscription/SignUpAttempt', payload, config);
  } catch (err) {
    throw generateError(err);
  }
};
const getSubscriptionPlans = async (payload, config) => {
  try {
    return await axios.get('/api/v1/subscription/plans', config);
  } catch (err) {
    throw generateError(err);
  }
};
const postNewSubscribe = async payload => {
  try {
    var _res$data;
    const res = await axios.post(`/scriptService/signin.asmx/Subscribe`, payload);
    const parsedResponse = camelCaseNormalizer(JSON.parse(res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 || (_res$data = _res$data.d) === null || _res$data === void 0 ? void 0 : _res$data.responseText));
    return {
      data: parsedResponse
    };
  } catch (e) {
    var _e$response;
    if ((e === null || e === void 0 || (_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.status) !== 200) {
      // When non 200 errors come back it is almost always a system error.
      throw new Error(processError(e).processedMessage());
    } else {
      throw generateError(e);
    }
  }
};

const postAccountAddModify = async payload => {
  try {
    const res = await axios.post('/ws/customers/AccountAddModify', payload);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not update company setting.');
  }
};

// deprecated
const blockHotel = async propId => {
  try {
    const res = await axios.put(`/api/v1/hotels/${propId}/block`);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not block hotel.');
  }
};

// deprecated
const unblockHotel = async propId => {
  try {
    const res = await axios.delete(`/api/v1/hotels/${propId}/block`);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not unblock hotel.');
  }
};
const putVendorPreference = async (preferenceObject, prefId) => {
  try {
    return await axios.put(`/api/v1/Account/vendorPreference/${prefId}`, preferenceObject).data;
  } catch (err) {
    return generateError(err, 'Could not modify supplier relationship.');
  }
};
const postVendorPreference = async preferenceObject => {
  try {
    return await axios.post(`/api/v1/Account/vendorPreference/`, preferenceObject).data;
  } catch (err) {
    return generateError(err, 'Could not add supplier relationship.');
  }
};
const deleteVendorPreference = async id => {
  try {
    const res = await axios.delete(`/api/v1/Account/vendorPreference/${id}`);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not delete vendor preference.');
  }
};
const putSSO = async values => {
  const payload = values;
  try {
    const res = await axios.put(`/api/v1/Account/SSO`, payload);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not edit SSO configuration.');
  }
};
const getSSO = async () => {
  try {
    const res = await axios.get(`/api/v1/Account/SSO`);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not unblock hotel.');
  }
};
const postSSO = async values => {
  try {
    const res = await axios.post(`/api/v1/Account/SSO`, values);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not add SSO configuration.');
  }
};
const deleteSSO = async values => {
  try {
    const res = await axios.delete(`/api/v1/Account/SSO/${values.subdomain}`);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not delete SSO configuration.');
  }
};
const updateSSOCertificate = async (subdomain, certificate) => {
  const url = `/api/v1/Account/SSO/${subdomain}/Certificate`;
  const data = [certificate];
  const headers = {
    'Content-Type': 'application/json'
  };
  try {
    const response = await axios.put(url, data, {
      headers
    });
    return response.data; // You can adjust based on your API response structure
  } catch (error) {
    return generateError(error, 'Coudl not update SSO certificate.');
  }
};
const approveSSOCertificate = async subdomain => {
  const url = `/api/v1/Account/SSO/${subdomain}/Certificate/Approve`;
  try {
    const response = await axios.put(url, null, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    return generateError(error, 'Coudl not approve SSO certificate.');
  }
};
const revertSSOCertificate = async subdomain => {
  const url = `/api/v1/Account/SSO/${subdomain}/Certificate/Revert`;
  try {
    const response = await axios.put(url, null, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    return generateError(error, 'Coudl not revert SSO certificate.');
  }
};
const renameSSOSubdomain = async (oldSubdomain, newSubdomain) => {
  const url = `/api/v1/Account/SSO/${oldSubdomain}/Rename/${newSubdomain}`;
  try {
    const response = await axios.put(url, null, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    return generateError(error, 'Coudl not rename subdomain.');
  }
};
const updateReport = async data => {
  try {
    const res = await axios.put(`/api/v1/AutomatedReportConfig`, data);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not unblock hotel.');
  }
};
const createReport = async data => {
  try {
    const res = await axios.post(`/api/v1/AutomatedReportConfig`, data);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not unblock hotel.');
  }
};
const deleteReport = async reportConfigId => {
  try {
    const res = await axios.delete(`/api//v1/AutomatedReportConfig/${reportConfigId}`);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not delete SSO configuration.');
  }
};
const getAutomatedReports = async anum => {
  try {
    const res = await axios.get(`/api/v1/AutomatedReportConfig/${anum}`);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not unblock hotel.');
  }
};

const fetchProfileById = async profileId => {
  try {
    const res = await axios.get(`/api/v1/profiles/${profileId}`);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not fetch profile.');
  }
};
const fetchProfileByEmail = async email => {
  try {
    const res = await axios.get(`/api/v1/profiles/search?email=${email}`);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not fetch profile.');
  }
};
const getPatchFields = payload => Object.keys(payload).map(key => {
  if (payload[key] instanceof Array) {
    return key;
  }
  return Object.keys(payload[key]).map(fieldName => `${key}.${fieldName}`);
}).join(',');
const patchProfile = async (profileId, profileData) => {
  const patchFields = getPatchFields(profileData);
  console.log('PatchFields', patchFields);
  try {
    const res = await axios.patch(`/api/v1/profiles/${profileId}`, {
      patchFields,
      ...profileData
    }, {
      headers: patchFields
    });
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not patch profile.');
  }
};
const updateProfile = async (nameNum, profileData) => {
  const payload = {
    nameNum,
    ...profileData
  };
  try {
    const res = await axios.post(`/ws/customers/UserAddModify`, payload);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not update profile.');
  }
};
const initiateTripIt = async params => {
  try {
    const res = await axios.get(`/ws/customers/UserInitiateTripItLink?queryparams=${JSON.stringify(params)}`);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not link TripIt');
  }
};
const unlinkTripIt = async params => {
  try {
    const res = await axios.get(`/ws/customers/UserRemoveTripItLink?queryparams=${JSON.stringify(params)}`);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not unlink TripIt');
  }
};

const getProfileImageService = async function () {
  let profileId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  try {
    const res = await axios.get(`/api/v1/profiles/${profileId}/image`);
    return res.data;
  } catch (err) {
    generateError(err, 'Could not fetch image.');
  }
};
const postProfileImageService = async function () {
  let profileId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  let payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  try {
    const res = await axios.post(`/api/v1/profiles/${profileId}/image`, {
      profileImage: '',
      ...payload
    });
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not upload image.');
  }
};
const deleteProfileImageService = async function () {
  let profileId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  try {
    const res = await axios.delete(`/api/v1/profiles/${profileId}/image`);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not delete image.');
  }
};

const postPolicyAddModify = async payload => {
  try {
    const res = await axios.post('/ws/customers/PolicyAddModify', payload);
    return res.data;
  } catch (err) {
    return generateError(err);
  }
};
const clonePolicy = async (policyId, newPolicyName) => {
  try {
    const res = await axios.post(`/api/v1/policy/${policyId}/clone?name=${newPolicyName}`);
    return res.data;
  } catch (err) {
    return generateError(err);
  }
};

const fetchTrackers = async () => {
  const res = await axios.get('/api/v1/FareTracker').catch(e => generateError(e, 'Could not fetch faretrackers.'));
  return res.data;
};
const fetchTrackerById = async trackerId => {
  try {
    const res = await axios.get(`/api/v1/FareTracker/${trackerId}`);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not fetch Tracker.');
  }
};
const postTracker = async trackerData => {
  try {
    const res = await axios.post('/api/v1/FareTracker', trackerData);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not post Tracker.');
  }
};
const getFields = payload => Object.keys(payload).join(',');
const patchTracker = async (trackerId, entity) => {
  const patchFields = getFields(entity);
  try {
    const res = await axios.patch(`/api/v1/FareTracker/${trackerId}`, {
      patchFields,
      entity
    });
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not patch tracker.');
  }
};
const deleteTracker = async trackerId => {
  try {
    const res = await axios.delete(`/api/v1/FareTracker/${trackerId}`);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not delete tracker');
  }
};
const priceCheckTracker = async trackerId => {
  try {
    const res = await axios.get(`/api/v1/FareTracker/${trackerId}/RefreshFare`);
    return res.data;
  } catch (err) {
    return generateError(err, 'Could not refresh tracker');
  }
};

const genericSearch = async keyword => {
  try {
    const res = await axios.get(`/api/v1/genericsearch?keyword=${keyword}`);
    return res.data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

var ReadyStates;
(function (ReadyStates) {
    ReadyStates[ReadyStates["CONNECTING"] = 0] = "CONNECTING";
    ReadyStates[ReadyStates["OPEN"] = 1] = "OPEN";
    ReadyStates[ReadyStates["CLOSED"] = 2] = "CLOSED";
})(ReadyStates || (ReadyStates = {}));
var StarRatings;
(function (StarRatings) {
    StarRatings[StarRatings["One"] = 1] = "One";
    StarRatings[StarRatings["Two"] = 2] = "Two";
    StarRatings[StarRatings["Three"] = 4] = "Three";
    StarRatings[StarRatings["Four"] = 8] = "Four";
    StarRatings[StarRatings["Five"] = 16] = "Five";
})(StarRatings || (StarRatings = {}));
var HotelSearchSource;
(function (HotelSearchSource) {
    HotelSearchSource["HotelsHomePage"] = "H";
    HotelSearchSource["ModifiedHotelSearch"] = "M";
    HotelSearchSource["StringPage"] = "T";
    HotelSearchSource["ConfirmationPage"] = "C";
    HotelSearchSource["CrossComparePage"] = "X";
})(HotelSearchSource || (HotelSearchSource = {}));
var ProgressStates;
(function (ProgressStates) {
    ProgressStates["NotStarted"] = "NotStarted";
    ProgressStates["InProgress"] = "InProgress";
    ProgressStates["Complete"] = "Complete";
})(ProgressStates || (ProgressStates = {}));

// If we need a processor, import it or define it here and implement it in the reducer.
var Actions;
(function (Actions) {
    Actions["SET_READY_STATE"] = "SET_READY_STATE";
    Actions["INIT_DATA"] = "INIT_DATA";
    Actions["RESET_DATA"] = "RESET_DATA";
    Actions["SET_ERROR"] = "SET_ERROR";
    Actions["RESET_ERROR"] = "RESET_ERROR";
})(Actions || (Actions = {}));
var initialState = {
    connectionState: ReadyStates.CLOSED,
    progress: ProgressStates.NotStarted,
    feedback: [],
    hotels: [],
    error: null,
    search: null,
};
var reducer = function (state, action) {
    switch (action.type) {
        case Actions.SET_READY_STATE:
            return __assign(__assign({}, state), { connectionState: action.payload });
        case Actions.INIT_DATA:
            return __assign(__assign({}, state), action.payload);
        case 'start':
            return __assign(__assign({}, state), { progress: ProgressStates.InProgress });
        case 'feedback': {
            var newFeedback = action.payload.data;
            return __assign(__assign({}, state), { feedback: __spreadArray(__spreadArray([], state.feedback, true), [newFeedback], false) });
        }
        case 'data': {
            var _a = action.payload, code = _a.code, data = _a.data;
            switch (code) {
                case 'Hotels':
                    return __assign(__assign({}, state), { hotels: data });
                case 'HotelShoppingResult': {
                    var _b = data, hotels = _b.hotels, search = _b.search;
                    return __assign(__assign({}, state), { hotels: hotels, search: search });
                }
                default:
                    console.warn('Unsupported sseCode', code);
                    return state;
            }
        }
        case 'error':
            console.warn('We should consider throwing here.', action);
            return __assign({}, state);
        case 'end':
            return __assign(__assign({}, state), { progress: ProgressStates.Complete });
        case Actions.RESET_DATA: {
            return __assign({}, initialState);
        }
        case Actions.SET_ERROR: {
            return __assign(__assign({}, state), { progress: ProgressStates.Complete, error: action.payload });
        }
        case Actions.RESET_ERROR: {
            return __assign(__assign({}, state), { error: action.payload });
        }
        default:
            return state;
    }
};
var getActions = function (dispatch) { return ({
    setReadyState: function (readyState) {
        dispatch({ type: Actions.SET_READY_STATE, payload: readyState });
    },
    handleMessage: function (eventData) {
        var sseType = eventData.sseType, code = eventData.sseCode, data = eventData.ssePayload;
        dispatch({ type: sseType, payload: { code: code, data: data } });
    },
    resetData: function () {
        dispatch({ type: Actions.RESET_DATA });
    },
    setHookData: function (payload) {
        dispatch({ type: Actions.INIT_DATA, payload: payload });
    },
    setError: function (payload) {
        dispatch({ type: Actions.SET_ERROR, payload: payload });
    },
    resetError: function () {
        dispatch({ type: Actions.RESET_ERROR, payload: null });
    },
}); };

var InStoreCache = /** @class */ (function () {
    function InStoreCache(opts) {
        this.defaultOpts = {
            prefix: 'ATS',
            name: 'webservice',
            ttl: 300000, // 5 minutes
            storage: window.sessionStorage,
        };
        this.opts = this.defaultOpts;
        this.setOpts(opts);
        this.clearCacheOnReload();
    }
    InStoreCache.prototype.setOpts = function (opts) {
        this.opts = __assign(__assign({}, this.defaultOpts), (opts !== null && opts !== void 0 ? opts : {}));
    };
    /**
     * Clears all cache entries that match the prefix.
     * @returns {string[]} The keys that were cleared.
     */
    InStoreCache.prototype.clearCacheByPrefix = function () {
        var _this = this;
        return Object.keys(this.opts.storage)
            .filter(function (k) { return k.indexOf(_this.opts.prefix) === 0; })
            .map(function (key) {
            _this.opts.storage.removeItem(key);
            return key;
        });
    };
    InStoreCache.prototype.makeKey = function (key) {
        return "".concat(this.opts.prefix, "_").concat(this.opts.name, "_").concat(key);
    };
    /**
     * Writes a value to the cache with key
     * @param key
     * @param value
     */
    InStoreCache.prototype.writeToStorage = function (key, value) {
        var cacheValue = JSON.stringify({
            value: value,
            expires: Number(new Date().getTime()) + this.opts.ttl,
        });
        try {
            this.opts.storage.setItem(key, cacheValue);
        }
        catch (err) {
            if (err instanceof Error) {
                // If the cache is too large, clear out all entries from this
                if (err.name === 'QuotaExceededError') {
                    this.clearCacheByPrefix();
                    this.opts.storage.setItem(key, cacheValue);
                }
                else {
                    throw err;
                }
            }
        }
    };
    /**
     * Calls the clearCacheByPrefix function if the page was reloaded.
     * It is advised to use this function outside of any render functions.
     */
    InStoreCache.prototype.clearCacheOnReload = function () {
        var wasRefreshed = window.performance.navigation.type === 1;
        return wasRefreshed ? this.clearCacheByPrefix() : [];
    };
    InStoreCache.prototype.get = function (key) {
        var cacheKey = this.makeKey(key);
        var cacheValue = this.opts.storage.getItem(cacheKey);
        if (cacheValue) {
            var parsed = JSON.parse(cacheValue);
            if (parsed.expires > new Date().getTime()) {
                return parsed.value;
            }
        }
        return null;
    };
    InStoreCache.prototype.set = function (key, value) {
        this.writeToStorage(this.makeKey(key), value);
    };
    return InStoreCache;
}());

// Define this here so it is a singleton.
var eventSrc = null;
var getReadyState = function (e) {
    if (e) {
        return e.readyState;
    }
    return ReadyStates.CLOSED;
};
var DEFAULT_URI$1 = '/api/v1/hotels';
/**
 * Filter out empty params and encode the rest to query string
 */
var makeQueryString$1 = function (params) {
    return Object.keys(params)
        .filter(function (k) { return params[k]; })
        .map(function (k) {
        // Must appease the mighty typescript compiler.
        var elem = params[k];
        return elem !== undefined ? "".concat(k, "=").concat(encodeURIComponent(elem)) : '';
    })
        .join('&');
};
var lastUsedQueryString$1;
var hsCache$1;
var useHotelShoppingSse = function (config) {
    var _a;
    var resolvedUri = (_a = config === null || config === void 0 ? void 0 : config.baseUri) !== null && _a !== void 0 ? _a : DEFAULT_URI$1;
    var _b = useReducer(reducer, initialState), state = _b[0], dispatch = _b[1];
    var _c = useMemo(function () { return getActions(dispatch); }, [dispatch]), handleMessage = _c.handleMessage, setReadyState = _c.setReadyState, resetData = _c.resetData, setHookData = _c.setHookData;
    var previousProgress = useRef(state.progress);
    // Initialize the cache on first render.
    useEffect(function () {
        hsCache$1 = new InStoreCache({ name: 'sse_hotel_shopping', ttl: 5 * 60 * 1000, storage: window.sessionStorage });
    }, []);
    var disconnect = useCallback(function () {
        if (eventSrc) {
            eventSrc.close();
            setReadyState(eventSrc.readyState);
            eventSrc = null;
        }
    }, [setReadyState]);
    var connect = useCallback(function (params) {
        var queryString = makeQueryString$1(params);
        lastUsedQueryString$1 = queryString;
        var cachedState = hsCache$1.get(queryString);
        if (cachedState) {
            setHookData(cachedState);
            return;
        }
        var uri = "".concat(resolvedUri, "?").concat(queryString);
        resetData();
        eventSrc = new EventSource(uri);
        eventSrc.onmessage = function (event) {
            var data = JSON.parse(event.data);
            if (data.sseType === 'end') {
                disconnect();
            }
            handleMessage(data);
        };
        eventSrc.onerror = function (err) {
            // The error provided by EventSource is useless. Log it out anyway.
            console.error(err);
            disconnect();
            throw new Error("CONNECTION ERROR: Unable to connect to ".concat(uri));
        };
    }, []);
    var actions = useMemo(function () {
        return { connect: connect, disconnect: disconnect };
    }, [connect, disconnect]);
    var memoizedState = useMemo(function () {
        return __assign(__assign({}, state), { connectionState: getReadyState(eventSrc) });
    }, [state]);
    // Cache the state when the progress changes from in progress to complete.
    // We cannot cache the state in the connect call because it is a closure and
    // the state will be stale by the time we want to write to the cache.
    if (previousProgress.current !== state.progress) {
        if (previousProgress.current === ProgressStates.InProgress &&
            state.progress === ProgressStates.Complete &&
            lastUsedQueryString$1) {
            hsCache$1.set(lastUsedQueryString$1, state);
        }
        previousProgress.current = state.progress;
    }
    return [memoizedState, actions];
};

var DEFAULT_URI = '/api/v2/hotels';
/**
 * Filter out empty params and encode the rest to query string
 */
var makeQueryString = function (params) {
    return Object.keys(params)
        .filter(function (k) { return params[k]; })
        .map(function (k) {
        // Must appease the mighty typescript compiler.
        var elem = params[k];
        return elem !== undefined ? "".concat(k, "=").concat(encodeURIComponent(elem)) : '';
    })
        .join('&');
};
var lastUsedQueryString;
var hsCache;
function useHotelShopping(config) {
    var _this = this;
    var _a;
    var resolvedUri = (_a = config === null || config === void 0 ? void 0 : config.baseUri) !== null && _a !== void 0 ? _a : DEFAULT_URI;
    var _b = useReducer(reducer, initialState), state = _b[0], dispatch = _b[1];
    var _c = useMemo(function () { return getActions(dispatch); }, [dispatch, config]), handleMessage = _c.handleMessage, resetData = _c.resetData, setHookData = _c.setHookData, setError = _c.setError, resetError = _c.resetError;
    var previousProgress = useRef(state.progress);
    var hotelShopping = useCallback(function (uri_1, abortController_1) {
        var args_1 = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args_1[_i - 2] = arguments[_i];
        }
        return __awaiter(_this, __spreadArray([uri_1, abortController_1], args_1, true), void 0, function (uri, abortController, lastCall) {
            if (lastCall === void 0) { lastCall = false; }
            return __generator(this, function (_a) {
                resetError();
                return [2 /*return*/, axios
                        .get(uri, __assign({ signal: abortController.signal }, config === null || config === void 0 ? void 0 : config.reqConfigs))
                        .then(function (res) {
                        if (lastCall) {
                            handleMessage({ sseType: 'data', sseCode: 'HotelShoppingResult', ssePayload: res.data });
                            handleMessage({ sseType: 'end', sseCode: null, ssePayload: null });
                        }
                        else {
                            handleMessage({ sseType: 'data', sseCode: 'Hotels', ssePayload: res.data.hotels });
                        }
                    })
                        .catch(function (err) {
                        var error = processError(err);
                        console.error(error);
                        setError(error);
                        abortController.abort();
                    })];
            });
        });
    }, [config]);
    // Initialize the cache on first render.
    useEffect(function () {
        hsCache = new InStoreCache({
            name: 'promise_based_hotel_shopping',
            ttl: 5 * 60 * 1000,
            storage: window.sessionStorage,
        });
    }, []);
    // When using this hook disconnect is a noop. Might make this the cancel call though.
    var disconnect = function () { };
    // Change setting in app. By default this will only make one call and will not show price loading.
    // Switching withRatesCallOnly off will show price loading
    var connect = function (params_1) {
        var args_1 = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args_1[_i - 1] = arguments[_i];
        }
        return __awaiter(_this, __spreadArray([params_1], args_1, true), void 0, function (params, parallel, withRatesCallOnly) {
            var queryString, cachedState, runDataSetter, abortController1, abortController2, uri, firstCall, finalCall;
            if (parallel === void 0) { parallel = true; }
            if (withRatesCallOnly === void 0) { withRatesCallOnly = true; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (state.progress === ProgressStates.Complete) {
                            resetData();
                        }
                        queryString = makeQueryString(params);
                        lastUsedQueryString = queryString;
                        cachedState = hsCache.get(queryString);
                        if (cachedState) {
                            runDataSetter = function () {
                                // Setting timeout to fix resetData race condition with resetData.
                                return setTimeout(function () {
                                    setHookData(cachedState);
                                }, 1);
                            };
                            runDataSetter();
                            return [2 /*return*/];
                        }
                        abortController1 = new AbortController();
                        abortController2 = new AbortController();
                        uri = "".concat(resolvedUri, "?").concat(queryString);
                        resetData();
                        // Send a start event to handleMessage
                        handleMessage({ sseType: 'start', sseCode: null, ssePayload: null });
                        firstCall = function () { return hotelShopping("".concat(uri, "&withRates=false"), abortController1); };
                        finalCall = function () { return hotelShopping("".concat(uri, "&withRates=true"), abortController2, true); };
                        if (!withRatesCallOnly) return [3 /*break*/, 1];
                        finalCall();
                        return [3 /*break*/, 5];
                    case 1:
                        if (!parallel) return [3 /*break*/, 2];
                        // Call the first promise
                        firstCall();
                        // Call the second promise
                        finalCall();
                        return [3 /*break*/, 5];
                    case 2: return [4 /*yield*/, firstCall()];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, finalCall()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    var actions = useMemo(function () {
        return { connect: connect, disconnect: disconnect };
    }, [connect, disconnect, config]);
    var memoizedState = useMemo(function () {
        // Connection state is only used by SSE. It has no purpose here.
        return __assign(__assign({}, state), { connectionState: 'DERP!' });
    }, [state]);
    // Cache the state when the progress changes from in progress to complete.
    // We cannot cache the state in the connect call because it is a closure and
    // the state will be stale by the time we want to write to the cache.
    if (previousProgress.current !== state.progress) {
        if (previousProgress.current === ProgressStates.InProgress &&
            state.progress === ProgressStates.Complete &&
            lastUsedQueryString) {
            hsCache.set(lastUsedQueryString, state);
        }
        previousProgress.current = state.progress;
    }
    return [memoizedState, actions];
}

var ContentSource;
(function (ContentSource) {
    ContentSource[ContentSource["Apollo"] = 1] = "Apollo";
    ContentSource[ContentSource["EAN"] = 2] = "EAN";
    ContentSource[ContentSource["Internal"] = 4] = "Internal";
    ContentSource[ContentSource["EANRapid"] = 8] = "EANRapid";
    ContentSource[ContentSource["Sabre"] = 16] = "Sabre";
    ContentSource[ContentSource["Amtrav"] = 32] = "Amtrav";
    ContentSource[ContentSource["Arise"] = 64] = "Arise";
})(ContentSource || (ContentSource = {}));
/**
 * This for the SSE endpoint that is not currently used.
 */
// export type HotelResultSSE = {
//   propId: string;
//   vendorHotelId: string;
//   vendorSource: number;
//   starRating: number;
//   reviewRate: number;
//   reviewCount: number;
//   hotelName: string;
//   hotelAddress: {
//     address1: string;
//     city: string;
//     state: string;
//     zip: string;
//   };
//   area: string;
//   distance: number;
//   geoLat: number;
//   geoLon: number;
//   travelerBookings: number;
//   colleaguesVisited: number;
//   colleagueNames: string[];
//   isPreferred: boolean;
//   soldOut: boolean;
//   policyViolations: string[];
//   averageBaseRate: number;
//   averageNightlyRate: number;
//   hotelImages: string[];
//   vendorPromo: {
//     promoText: null;
//     vendorPromoText: string;
//     valueAdds: ValueAdd[];
//   };
//   latitude: number;
//   longitude: number;
//   hotelRating: 0 | 1 | 2 | 3 | 4 | 5;
//   alliance: string;
//   averageNightlyRateRefundable: number;
//   chain: string;
//   hasRefundableRate: boolean;
//   order: number;
// };
// export type HotelShoppingResultSSE = {
//   search: SearchDetails;
//   hotels: HotelResult[];
// };

const getCarList = async configs => {
  try {
    const res = await axios.get(`/api/v1/cars`, configs);
    return res.data;
  } catch (err) {
    throw generateError(err, 'Could not fetch car list.');
  }
};
const getCarReferenceData = async configs => {
  try {
    const res = await axios.get(`/api/v1/cars/referenceData`, configs);
    return res.data;
  } catch (err) {
    throw generateError(err, 'Could not fetch car reference data.');
  }
};

function makeAppApiProvider(stub) {
    if (stub === void 0) { stub = null; }
    var AppApiContext = createContext(null);
    var StubProvider = function (_a) {
        var children = _a.children;
        return React.createElement(AppApiContext.Provider, { value: stub }, children);
    };
    var useAppApi = function () {
        var appApi = useContext(AppApiContext);
        if (!appApi) {
            throw new Error("AppApi Provider not found!!! Please be sure to wrap any component \n        that uses the \"useWebservice\" hook with the WebserviceContext provider");
        }
        return appApi;
    };
    return { useAppApi: useAppApi, AppApiContext: AppApiContext, StubProvider: StubProvider };
}

export { BOOKING_ATTACHMENT_TYPES, ContentSource, ProgressStates as HotelProgressStates, HotelSearchSource, INVITE_STATUS_TYPES, RSVP_STATUSES, ReadyStates, StarRatings, WebServiceError, addAttendee, addMultipleAttendees, addRoomBlock, approveSSOCertificate, blockHotel, bookingApproveOrReject, bookingModPendingAlert, bookingsByTripSegment, cacheDefaultOpts, camelCaseNormalizer, cancellableFindLocations, cancellableFindLocationsNearBy, capitalCaseNormalizer, changeTripApplyChanges, clearCacheByPrefix, clearCacheOnReload, clearShopForFlightsCache, clonePolicy, createReport, deleteAttendee, deleteMeeting, deleteProfileImageService, deleteReport, deleteRoomBlock, deleteSSO, deleteSettings, deleteTracker, deleteVendorPreference, downloadAttendeeList, downloadBlob, downloadCventAirActuals, downloadFile, downloadFlightReport, downloadRoomList, editTripBillingTags, editTripTitle, emailSubscriber, fetchAccountData, fetchBookingComponents, fetchCmsPost, fetchInvariantData, fetchLocationData, fetchLowestFareData, fetchLowestReturnData, fetchMeetingById, fetchMeetingByInvitationToken, fetchMeetings, fetchMeetingsRefData, fetchPolicy, fetchProfileByEmail, fetchProfileById, fetchSeatMapByBookNum, fetchTrackerById, fetchTrackers, fetchTravelAlerts, fetchTripsData, fetchUserData, findLocations, findLocationsNearBy, generateError, genericSearch, getAirportOptions, getAttendeeBookings, getAttendees, getAutomatedReports, getBookingService, getCarList, getCarReferenceData, getChangeTripActions, getCustomerTravelerInfo, getHotelDetails, getHotelProperty, getHotelReviews, getHotelRooms, getHotelVCardImages, getHotels, getHotelsMultiSource, getInvites, getLogonProfile, getLoyaltyNumbers, getPdpCheck, getProfileImageService, getSSO, getSubscriptionPlans, getTravelerInfo, getUserData, initiateTripIt, isObject, isObjectOrArray, locationDataUrl, lowestFareDataUrl, lowestFareReturnDataUrl, makeAppApiProvider, makeErrorHandledFunction, manageTripsCheck, manageTripsSendEmail, objectKeyNormalizer, patchChangeTripActions, patchMeeting, patchProfile, patchTracker, postAccountAddModify, postBookingCancelService, postCloneMeeting, postCreateBookingService, postEmailItinService, postExpeditedBooking, postMeeting, postMeetingInvitation, postNewSubscribe, postPolicyAddModify, postProfileImageService, postRoomDetails, postSSO, postSignUpAttempt, postTracker, postVendorPreference, postVirtualCardInfoService, priceCheckTracker, putSSO, putVendorPreference, registerUser, renameSSOSubdomain, revertSSOCertificate, seatAvailability, setDeclineStatus, setRsvpStatus, shopForFlights, shopForFlightsWithCache, unblockHotel, unlinkTripIt, updateAttendee, updateProfile, updateReport, updateSSOCertificate, useHotelShopping, useHotelShoppingSse, withCache };
//# sourceMappingURL=index.js.map
